module.exports = __webpack_public_path__ + "img/fas-volume-off.9ef98ec2.svg";